module.exports = __webpack_public_path__ + "media/application/images/x-circle-6e82a69ef9f914c75a4772d104a63084.svg";